import type { LegacyRef, MutableRefObject, RefCallback } from "react";
// biome-ignore lint/style/noRestrictedImports: encapsulation
import reactMergeRefs from "react-merge-refs";

import { isPresent } from "~/tools/is-present";

export function mergeRefs<T>(refs: Array<null | undefined | MutableRefObject<T> | LegacyRef<T>>): RefCallback<T> {
	return reactMergeRefs(refs.filter(isPresent));
}
